import "./Header.scoped.css";

const Header = (props) => {
  return (
    <header>
      <h1>Hello World</h1>
    </header>
  );
};

export default Header;
